<div class="container" *ngIf="providerDetails && form">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <h2>{{providerName}}</h2>
        <div class="check-provider">
            <table *ngIf="providerDetails">
                <tr *ngFor="let detail of providerDetails.Data">
                    <td> {{detail[0]}}</td>
                    <td>{{detail[1]}}</td>
                </tr>
            </table>
            <div *ngIf="form" [formGroup]="form">
                <div>
                    <label> {{ 'label.amount' | translate }}</label>
                    <input [value]="amount" type="number" [attr.disabled]="providerDetails.AmountDisable ? true : null"
                        (keyup)="onKeyUp($event)" formControlName="amount">
                    <p [hidden]="!commissionAmount">{{ 'label.commission' | translate }} {{commissionAmount}} </p>
                </div>
            </div>
            <button [disabled]='buttonDisabled'>{{ 'label.pay' | translate }}</button>
        </div>
    </form>
</div>
<app-popup [(show)]="showPopup" [messages]="popupMessages" [message]="popupMessage" (closed)="showPopup = $event">
</app-popup>
<app-loading *ngIf="!commissions || showLoading"></app-loading>